export default {
  guid: '',
  tokenData: {},
  metadata: {},
  pageNotFound: 0,
}